import {
	useState,
	useEffect,
	useRef,
	useCallback,
} from 'react';

export const useCountdown = (initialDuration: number) => {
	const LOCAL_STORAGE_KEY = 'countdownTarget';
	const [timeLeft, setTimeLeft] = useState<number | null>(
		null
	);
	const intervalRef = useRef<number | null>(null);

	const startCountdown = useCallback(() => {
		const targetTime = Date.now() + initialDuration;
		localStorage.setItem(
			LOCAL_STORAGE_KEY,
			targetTime.toString()
		);
		setTimeLeft(targetTime - Date.now());
	}, [initialDuration]);

	const stopCountdown = useCallback(() => {
		if (intervalRef.current)
			clearInterval(intervalRef.current);
		setTimeLeft(null);
		localStorage.removeItem(LOCAL_STORAGE_KEY);
	}, []);

	useEffect(() => {
		const storedTarget = localStorage.getItem(
			LOCAL_STORAGE_KEY
		);
		const targetTime = storedTarget
			? parseInt(storedTarget, 10)
			: null;

		if (targetTime && targetTime > Date.now()) {
			setTimeLeft(targetTime - Date.now());
		}
	}, []);

	useEffect(() => {
		if (timeLeft === null) return;

		intervalRef.current = window.setInterval(() => {
			setTimeLeft((prev) => {
				if (prev && prev <= 1000) {
					clearInterval(intervalRef.current!);
					localStorage.removeItem(LOCAL_STORAGE_KEY);
					return null;
				}
				return prev ? prev - 1000 : null;
			});
		}, 1000);

		return () => clearInterval(intervalRef.current!);
	}, [timeLeft]);

	return { timeLeft, startCountdown, stopCountdown };
};
